import { FC, useEffect, useRef } from "react";
import "./information.css";

interface Props {
  onClose: () => void;
}

export const Information: FC<Props> = ({ onClose }) => {
  const dialogRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const returnFocus = document.activeElement as HTMLElement;
    requestAnimationFrame(() => { document.documentElement.scrollTop = 0; });
    dialogRef.current?.focus();
    return () => { returnFocus?.focus(); };
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="modal-container">
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Information"
      tabIndex={-1}
      ref={dialogRef}
      className="modal"
    >
      <div className="modal-fei">
        <span className="modal-fei-title">FEI</span>
        <button onClick={onClose} aria-label="Close" className="modal-close">
          ×
        </button>
      </div>
      <div className="modal-content">
        <div className="modal-left">
          <section className="modal-contact">
            <p><a href="mailto:info@xiaofeistudio.co.uk">info@xiaofeistudio.co.uk</a></p>
            <p><a href="tel:+447803031381">+44 (0)780 303 1381</a></p>
            <p><a href="https://www.instagram.com/fei_xiaofeistudio" target="_blank" rel="noreferrer">Instagram @fei_xiaofeistudio</a></p>
          </section>
        </div>
        <div className="modal-right">
          <section>
            <p>Creative direction and design.</p>
            <p>Across disciplines, cultures and industries.</p>
          </section>
          <section>
            <h2>Scope of Work</h2>
            <p>Art Direction / Graphic Design / Identity / Publications / Film / Exhibition / Illustration / Branding / Campaign / Strategy / Positioning / Spatial / Experience / Digital / Image Creation / Packaging & Product / Music Supervision / Editorial Direction / Copywriting / Creative Advisory</p>
          </section>
          <section>
            <h2>Selected Clients</h2>
            <p>Tate / BFI / British Council / Warner / Virgin / EMI / Musician's Union / Sub Pop / Bella Union / One Little Indian / MTV / ATP / Pony Canyon / Nokia / Asia & Pacific Film Festival / Nordic Film Festival / Royal Opera House / Rocket Girl Records / Day For Night / Newport Street Gallery / Palm Casino / 798 Art Zone / People's Literature Publishing House / Writers Publishing House</p>
          </section>
          <section>
            <h2>Selected Artists</h2>
            <p>Damien Hirst / Johnny Depp / Patti Smith / Bjork / U2 / Red Hot Chilli Peppers / Kevin Shields</p>
          </section>
        </div>
      </div>
    </div>
    </div>
  );
};
